import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useHistory } from 'react-router-dom';
import { FaSearch, FaCheck, FaTimes } from 'react-icons/fa';
import translations from '../../translations/de';
import Table from '../../components/Table';
import Button from '../../components/Button';
import parkingAPI from '../../api/parking';

const ParkingFields = ({ store }) => {
    const history = useHistory();
    // Assigned/activated/available counts per field, for the status columns.
    const [countsByField, setCountsByField] = useState({});

    useEffect(() => {
        store.getFields();
        parkingAPI
            .getCounts({ params: {} })
            .then((res) => {
                const map = {};
                (res.data || []).forEach((c) => {
                    map[c.parking_field_id] = c;
                });
                setCountsByField(map);
            })
            .catch(() => {});
    }, [store]);

    const handleField = (id) => {
        store.selectField(id);
        history.push(`/parking-fields/${id}`);
    };

    const tableColumns = [
        { Header: 'ID', accessor: 'id', Cell: ({ value }) => <div>{value}</div> },
        {
            Header: translations.parking_field,
            accessor: 'name',
            Cell: ({ value }) => <div>{value}</div>,
        },
        {
            Header: translations.capacity,
            accessor: 'capacity',
            Cell: ({ value }) => <div>{value}</div>,
        },
        {
            Header: 'Zugeteilt',
            accessor: 'assigned',
            Cell: ({ value }) => <div>{value}</div>,
        },
        {
            Header: 'Aktiviert',
            accessor: 'activated',
            Cell: ({ value }) => <div>{value}</div>,
        },
        {
            Header: 'Nicht aktiviert',
            accessor: 'not_activated',
            Cell: ({ value }) => <div>{value}</div>,
        },
        {
            Header: 'Verfügbar',
            accessor: 'available',
            Cell: ({ value }) => <div>{value}</div>,
        },
        {
            Header: translations.uses_external_qr,
            accessor: 'uses_external_qr',
            Cell: ({ value }) => (
                <div>
                    {value ? <FaCheck className="confirm" /> : <FaTimes className="error" />}
                </div>
            ),
        },
        {
            Header: translations.sperr_dates,
            accessor: 'sperr_count',
            Cell: ({ value }) => <div>{value}</div>,
        },
        {
            Header: '',
            accessor: 'action',
            Cell: ({ row }) => (
                <Button onClick={() => handleField(row.cells[0].value)} title={translations.show}>
                    <FaSearch />
                </Button>
            ),
        },
    ];

    return (
        <div style={{ width: '100%' }}>
            <Table
                tableName={translations.parking_fields}
                columns={tableColumns}
                data={store.fields.map((f) => {
                    const c = countsByField[f.id] || {};
                    return {
                        id: f.id,
                        name: f.name,
                        capacity: f.capacity,
                        assigned: c.assigned ?? 0,
                        activated: c.activated ?? 0,
                        not_activated: c.not_activated ?? 0,
                        available: c.available ?? 0,
                        uses_external_qr: f.uses_external_qr,
                        sperr_count: f.sperr_dates.length,
                    };
                })}
            />
        </div>
    );
};

export default observer(ParkingFields);
